import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { getOrganizationByEmail } from 'nursd-dashboard/api/organizationTable';
import { authLogin } from 'nursd-dashboard/api/authOrganization';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { socket } from 'nursd-dashboard/api/socket';
import PropTypes from 'prop-types';

const LoginForm = ({ hasLabel }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });
  const [loading, setLoading] = useState(false);
  const { updateAuthToken, updateValues } = useAuth();
  const navigate = useNavigate(); // Initialize useNavigate

  const signIn = async (email, password) => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const resp = await authLogin({ email, password });
      const res = await getOrganizationByEmail(resp?.authToken, email);
      let arrState = [];
      if (res) {
        res?.locations.map(i =>
          arrState.push({
            location: i.location_id,
            state: i.location_state
          })
        );
        if (res?.locations.length === arrState.length) {
          await updateValues(
            arrState,
            arrState[0]?.location,
            res.organizationName
          );
          await updateAuthToken(
            resp?.authToken,
            res?.id?.toString(),
            res?.uniqueId?.toString()
          );
          let scr = {
            uniqueId: `manager${res?.id}`
          };
          socket?.emit('setup', scr);
          socket?.on('connected', () => console.log('Socket connected'));
          toast.success(`Logged in as ${email}`, {
            theme: 'colored'
          });
          navigate('/', { replace: true }); // Navigate to root path
        } else {
          throw new Error('Invalid location data');
        }
      } else {
        throw new Error('No organization data returned');
      }
    } catch (error) {
      toast.error(error?.message || 'Login failed', {
        theme: 'colored'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    signIn(formData.email, formData.password);
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email address' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password || loading}
        >
          {loading ? 'Loading...' : 'Log in'}
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
